module.exports = __webpack_public_path__ + "img/cuprolli_logo.41ae232f.svg";